/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import GeofenceAPIs from "../../../APIs/GeofenceAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import moment from "moment";
// import mixpanel from "mixpanel-browser";

const processData = (respObj, vehicleMap, selectedReportId, callback) => {
  let arr = [];
  let vehicleno;
  let item;
  for (let vehicleid in respObj) {
    vehicleno = (vehicleMap[vehicleid] || {}).vehicleno || "Not available";
    if (selectedReportId === 0) {
      for (let fencename in respObj[vehicleid]) {
        arr.push({
          vehicleno,
          fencename,
          numentries: respObj[vehicleid][fencename].numentries,
          numexits: respObj[vehicleid][fencename].numentries,
        });
      }
    } else {
      for (let fencename in respObj[vehicleid]) {
        for (let idx in respObj[vehicleid][fencename].entryexitdata) {
          item = respObj[vehicleid][fencename].entryexitdata[idx];
          arr.push({
            vehicleno,
            entrytime: item.entrytime
              ? moment(item.entrytime).format(dateFormat)
              : "NA",
            exittime: item.exittime
              ? moment(item.exittime).format(dateFormat)
              : "NA",
            fencename,
            entrysoc: item.entrysoc!==null ? item.entrysoc : "NA",      
            exitsoc: item.exitsoc !==null ? item.exitsoc :"NA",       
            entryodometer: item.entryodometer !==null ? item.entryodometer : "NA"  
          });
        }
      }
    }
  }
  callback(arr);
};

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Geofence Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  schema.finalData = null;
  let saveState = null;
  let tableStateData = {};
  let selectedReportId = (schema.selectedReport || {}).id;
  schema.processing = true;
  window.forceUpdateReportWindow();

  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    schema.processing = false;
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
  if (data.geofence && data.geofence.length && selectedReportId != null) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, selectedReportId, (data) => {
        schema.finalData = data;
        schema.processing = false;
        window.forceUpdateReportWindow();
        if (
          tableStateData[selectedReportId] &&
          tableStateData[selectedReportId][0]
        ) {
          tableStateData[selectedReportId][0].body = data;
          tableStateData[selectedReportId][0].busy = false;
          saveState(
            tableStateData[selectedReportId][0],
            tableStateData[selectedReportId][1],
            tableStateData[selectedReportId][2]
          );
        }
        if (schema.content[selectedReportId].ref) {
          schema.content[selectedReportId].ref.setData(data);
        }
      });
    };
    if (schema.content[selectedReportId].ref) {
      schema.content[selectedReportId].ref.setBusy(true);
      saveState = schema.content[selectedReportId].ref.props.saveState;
      tableStateData[selectedReportId] = [
        schema.content[selectedReportId].ref.state,
        schema.content[selectedReportId].ref.props.schemaKey,
        schema.content[selectedReportId].ref.props.data,
      ];
    }
    let body = {
      reportid: data.geofence.map((item) => {
        return item.data.reportid;
      })[0],
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    GeofenceAPIs.getReportHistory(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    console.log("Please select atleast one vehicle");
    schema.processing = false
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a Geofence and a Report type",
        content: "Please select a geofence and a report type.",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
  }
};

const onReportTypeChange = (report) => {
  schema.selectedReport = (report || [])[0];
  window.forceUpdateReportWindow();
};

const onGeoReportChange = (report) => {
  schema.selectedGeoReport = (report || [])[0];
  window.forceUpdateReportWindow();
};

const isReportTableShowable = (id) => {
  return schema.selectedReport && schema.selectedReport.id === id;
};

const isToolDisabled = () => {
  return !schema.processing;
};

const isGetButtonDisabled = () => {
  return isToolDisabled() && schema.selectedReport && schema.selectedGeoReport;
};

const isDownloadButtonDisabled = () => {
  return isToolDisabled() && schema.finalData;
};

const schema = {
  key: "geofence_report",
  name: "Geofence",
  processing:false,
  selectedGeoReport: [],
  selectedReport: [],
  finalData:null,
  toolbar: [
    {
      key: "geofence",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      isDisabled: isToolDisabled,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            let geofenceReport = (state.geofenceMap || {}).data || [];

            for (let idx in geofenceReport) {
              if (geofenceReport[idx].reportid) {
                newMap[geofenceReport[idx].reportid] = geofenceReport[idx];
              }
            }
            return newMap;
          })(),
          name: "reportname",
          id: "reportid",
        };
      },
      onItemChange: onGeoReportChange,
      report: "geofence",
    },
    {
      key: "starttime",
      isDisabled: isToolDisabled,
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      isDisabled: isToolDisabled,
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "reporttype",
      isDisabled: isToolDisabled,
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      storeData: (state) => {
        return {
          data: {
            0: { name: "Summary", id: 0 },
            1: { name: "History", id: 1 },
          },
          name: "name",
          id: "id",
        };
      },
      onItemChange: onReportTypeChange,
    },
    {
      key: "get_history",
      isDisabled: isGetButtonDisabled,
      type: schemaTypes.BUTTON,
      name: "Get Geofence Report",
      onClick: getHistory,
    },
    {
      key: "download",
      isDisabled: isDownloadButtonDisabled,
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: () => {
        // mixpanel.track("User Downloads Geofence Report", {
        //   Platform: "Web",
        //   Application: "Web",
        //   Screen: "Report",
        // });
        if (schema.finalData) {
          JSONToCSVConvertor(schema.finalData, "ViewReport", false);
        }
      },
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      isShowable: () => isReportTableShowable(0),
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "fencename", name: "", name: "Geofence" },
        { key: "numentries", name: "", name: "Number of Entries" },
        { key: "numexits", name: "", name: "Number of Exits" },
      ],
    },
    {
      key: "dataTable2",
      type: schemaTypes.IN_TABLE,
      isShowable: () => isReportTableShowable(1),
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "entrytime", name: "", name: "Entry Time" },
        { key: "exittime", name: "", name: "Exit Time" },
        { key: "fencename", name: "", name: "Geofence Name" },
        {key: "entrysoc",  name:"", name:"Start Soc"},
        {key:"exitsoc",name:"", name:"End Soc"},
        {key:"entryodometer",name:"",name:"Odometer"}
      ],
    },
  ],
};
export default schema;
